import { lazy } from 'react';
import { Route, Routes } from 'react-router';
import { NotFound } from '../../app/routing/NotFound';

const Search = lazy(() => import('./Search'));

export default function EcomSearchRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Search />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
